import BaseView from './BaseView';

let view = null;
// let hasScript = false;

class StartStory extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {
		// this.ensureJs();
	}

	// ensureJs() {
	// 	if (hasScript) {
	// 		return;
	// 	}

	// 	hasScript = true;

	// 	const script = document.createElement('script');
	// 	script.setAttribute('type', 'module');
	// 	script.setAttribute('src', `${WPURLS.laravel_url}/api/js/start-a-story`);
	// 	document.head.appendChild(script);

	// 	const style = document.createElement('style');
	// 	style.setAttribute('rel', 'stylesheet');
	// 	style.setAttribute('href', `${WPURLS.laravel_url}/api/js/start-a-story-css`);
	// 	document.head.appendChild(style);
	// }
}

export default {
	namespace: 'template-start-story',
	beforeEnter: ({ current, next, trigger }) => {
		view = new StartStory(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
